/* --- FILE: src/components/NavBar/NavBar.js --- */
import Container from 'react-bootstrap/Container';
import { useState, useEffect } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Row, Col, Image, ButtonGroup, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';
import axios from 'axios';
import { serverurl } from '../../providers/ServerUrl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

import './NavBar.css';

export function NavBar() {

  const [mynavbar, setMyNavBar] = useState(false);
  const [news, setNews] = useState([]);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200); // Check screen size on load

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  // Handle Scroll
  const changeBackground = () => {
    if (window.scrollY >= 50) {
      setMyNavBar(true);
    } else {
      setMyNavBar(false);
    }
  }

  // Handle Screen Resize (to switch logo dynamically)
  const handleResize = () => {
    setIsMobile(window.innerWidth < 1200);
  }

  useEffect(() => {
    window.addEventListener('scroll', changeBackground);
    window.addEventListener('resize', handleResize); // Listen for resize
    fetchNewsData();

    return () => {
      window.removeEventListener('scroll', changeBackground);
      window.removeEventListener('resize', handleResize);
    };
  }, [])

  const fetchNewsData = () => {
    return axios.get(serverurl + "/api/news")
      .then((response) => setNews(response.data['news']));
  };

  return (
    <>
      {/* --- TOP HEADER --- */}
      <div className="sub-header" id="sub-header">
        <Container fluid>
          <Row className="align-items-center justify-content-between">
            <Col lg={8} md={7} xs={12} className="text-center text-md-start mb-1 mb-md-0">
              <Carousel controls={false} indicators={false} interval={3000} className="news-carousel">
                {news && news.length > 0 ? news.map((newsData, index) => {
                  return (
                    <Carousel.Item key={index}>
                      <p className="news-text">
                        <span style={{color:'#f5a425', fontWeight:'bold'}}>LATEST NEWS:</span> {newsData.news_title}
                      </p>
                    </Carousel.Item>
                  )
                }) : <Carousel.Item><p className="news-text">Welcome to KCCC</p></Carousel.Item>}
              </Carousel>
            </Col>

            <Col lg={4} md={5} xs={12} className="text-center text-md-end">
              <div id="subheaderlink">
                <ButtonGroup size="sm">
                  <Link to="/signup" className='btn btn-outline-light btn-sm' id="subheaderbtn" reloadDocument>Sign Up</Link>
                  <Link to="/news" className='btn btn-outline-light btn-sm' id="subheaderbtn" reloadDocument>News</Link>
                  <Link to="/resources" className='btn btn-outline-light btn-sm' id="subheaderbtn" reloadDocument>Resources</Link>
                </ButtonGroup>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* --- MAIN NAVBAR --- */}
      <div className="navbar-area">
        <Navbar expand="xl" className={mynavbar ? 'mynavbar myactive' : 'mynavbar'}>
          <Container fluid>
            <Navbar.Brand href="/">
              <Image 
                fluid 
                /* Logic: If Scrolled OR Mobile => Black Logo. Else => White Logo */
                src={(mynavbar || isMobile) ? "images/logoblack.png" : "images/logowhite.png"}
                className="navbar-logo"
                alt="Logo" 
              />
            </Navbar.Brand>

            <Navbar.Toggle 
              aria-controls="offcanvasNavbar-expand-xl" 
              onClick={handleShow}
              className="custom-toggler"
            >
               <FontAwesomeIcon icon={faBars} size="lg" style={{ color: (mynavbar || isMobile) ? '#000' : '#fff' }} />
            </Navbar.Toggle>

            <Navbar.Offcanvas
              id="offcanvasNavbar-expand-xl"
              aria-labelledby="offcanvasNavbarLabel-expand-xl"
              placement="end"
              show={showOffcanvas}
              onHide={handleClose}
            >
              <Offcanvas.Header>
                <Offcanvas.Title id="offcanvasNavbarLabel-expand-xl">
                  <Image src="images/logoblack.png" width="180" alt="Logo" />
                </Offcanvas.Title>
                <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
              </Offcanvas.Header>
              
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3 align-items-center" id="mobile-nav-links">
                  <Nav.Link href="/" className='navLink' onClick={handleClose}>Home</Nav.Link>
                  <Nav.Link href="/about" className='navLink' onClick={handleClose}>About</Nav.Link>
                  <Nav.Link href="/sermons" className='navLink' onClick={handleClose}>Sermons</Nav.Link>
                  <Nav.Link href="/departments" className='navLink' onClick={handleClose}>Departments</Nav.Link>
                  <Nav.Link href="/events" className='navLink' onClick={handleClose}>Events</Nav.Link>
                  <Nav.Link href="/livestream" className='navLink' onClick={handleClose}>Livestream</Nav.Link>
                  <Nav.Link href="/podcasts" className='navLink' onClick={handleClose}>Podcasts</Nav.Link>
                  <Nav.Link href="/donation" className='navLink' onClick={handleClose}>Donation</Nav.Link>
                  <Nav.Link href="https://adeajalaministries.org/aamstore" className='navLink' target="_blank" onClick={handleClose}>E-Store</Nav.Link>
                  
                  <Nav.Link href="/give" onClick={handleClose} className='mt-3 mt-xl-0 ms-xl-3'>
                     <Button style={{ 
                        backgroundColor: 'red', 
                        borderColor: 'red', 
                        borderRadius: '50px', 
                        fontWeight: 'bold', 
                        padding: '10px 30px',
                        textTransform: 'uppercase'
                     }}>
                        GIVE
                     </Button>
                  </Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </div>
    </>
  );
}